import * as React from "react";
import {inject, observer} from "mobx-react";
import LoginForm from "@components/Login/FormikLogin"
import {HashRouter} from "react-router-dom";


@inject("store")
@observer
export default class Login extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        if (this.props.headerCallback) {
            // avoid re-render header when switching template
            this.props.headerCallback(null);
        }

        // const serverRender = typeof window === 'undefined';
        // if (serverRender) return;
        // this.scrollToTop("didMount");
    }


    render() {
        const pageContent = this.props.navigation.pageContent;
        const backgroundImage = pageContent.Properties.backgroundImage;

        return (
            <div className="site-selector">
                <div className="site-selector-background" style={{backgroundImage: "url('" + backgroundImage + "')"}}></div>
                <div style={{display: "flex", width: "100%", height: "100%", justifyContent: "center"}}>
                    <div style={{width: 600, margin: "auto 15px"}}>
                        <div className="row">
                            <div className="col-12">
                                <div className="card mb-3">
                                    <div className="card-body">
                                        {typeof window === 'undefined' ?
                                            null// <LoginForm />
                                            :
                                            <HashRouter hashType="noslash">
                                                <LoginForm/>
                                            </HashRouter>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

